export const SecurityModuleTranslations: Array<string> = [
    // title
    'Admin.Dkim.Enable',
    'Admin.Dkim.Enabled',
    'Admin.Dkim.Disabled',
    'Admin.Dkim.NewKey',
    'Admin.Dkim.Selector',
    'Admin.Dkim.Domain',
    'Admin.Dkim.SampleDomain',
    'Admin.Dkim.SelectEncryption',
    'Admin.Dkim.pubprivatekeys',
    'Admin.Dkim.Unchanged',
    'Admin.Dkim.LetCpqGenerate',
    'Admin.Dkim.EnterManually',
    'Admin.Dkim.PrivateKey',
    'Admin.Dkim.PublicKey',
    'Admin.Dkim.CertificatePassword',
    'Admin.Dkim.EnterPassword',
    'Admin.Dkim.UploadCert',
    'Admin.Dkim.UploadPFXFile',
    'Admin.Msg.CancelButton',
    'Admin.Msg.SaveKey',
    'Admin.Dkim.totalKeys',
    'Admin.Dkim.CopyCert',
    'Admin.Dkim.ErrorCopyCert',
    'Admin.Dkim.QuickSearch',
    'Admin.Dkim.Key',
    'Admin.Dkim.Active',
    'Admin.Dkim.CopyKey',
    'Admin.Dkim.DownloadKey',
    'Msg.Edit',
    'Msg.UploadNewfile',
    'Msg.OrSelectFromExisting',
    'Msg.Selectfile',
    'Admin.SuccessfullyDeleted',
    'Admin.AddCompany.Required',
    'Admin.Products.DeleteWarning',
    'Admin.CancelDeleteWarning',
    'xmlDKIM',

    // Certificate Management
    'Admin.CertificateManagement.NewCertificate',
    'Admin.CertificateManagement.Issuer',
    'Admin.CertificateManagement.ValidFrom',
    'Admin.CertificateManagement.ValidTo',
    'Admin.CertificateManagement.Purpose',
    'Admin.CertificateManagement.SoapUrl',
    'Admin.CertificateManagement.SelectKeySize',
    'Admin.DataProtection.Field',
    'Admin.CertificateManagement.FindByNameOrSoapUrl',
    'Admin.CertificateManagement.SignitureAlgorithm',
    'Admin.CertificateManagement.Thumbprint',
    'Admin.CertificateManagement.EnterSoapUrl',
    'Admin.CertificateManagement.NewCertificate',
    'Admin.CertificateManagement.SoapUrlMandatory',
    'Admin.AttributeImport.Column4_Value',
    'xmlCertificateManagement',
    'xsltDetails',
    'Admin.CertificateManagement.Details',
    'Admin.Dkim.CertificateRequired',
    'Admin.Dkim.ProtectCertificateWithPassword',
    'ActionsEdit.SoapUrlRequired',
    'Admin.add_edit_user.JSMSGPasswordMissing',
    'UserRegistration.DomainRequired',
    'Admin.add_edit_customer_visibility.LabelUser',
    'Admin.deflusersetup.PlaceholderForSelectUser',
    'Admin.CertificateManagement.Subject',
    'Admin.CertificateManagement.AlreadyMapped',
    'Admin.SystemCertificates',
    'Admin.UserCertificates',
    'Admin.CertificateManagement.CancelDeleteWarning',
    'Admin.CertificateManagement.SuccessfullyDeleted',
    'Admin.CertificateManagement.FindByUser',
    'Admin.CertificateManagement.Enable',
    'Admin.CertificateManagement.DeleteWarning',
    'Admin.CertificateManagement.UploadCerFile',
    'Admin.ClientCertificateAuthentication',
    'Admin.InboundSoapHeaderSigning',
    'Admin.SoapHeaderSigning',
    'Admin.FederationEncryptionCertifiate',
    'Admin.FederationSigningCertifiate',

    // Data deletion settings
    'Admin.Quotes',
    'Admin.Deletion.QuoteGeneral',
    'Admin.Deletion.QuoteByStatus',
    'Admin.Deletion.QuoteGeneralHint',
    'Admin.Deletion.BlockedQuotes',
    'Admin.PlaceholderForSelectBlockedObject',
    'Admin.Deletion.BlockedQuotesHint',
    'Admin.Deletion.QuotePeriod',
    'Admin.Deletion.QuoteByStatusHint',
    'Admin.Deletion.QuoteStatusPeriod',
    'Admin.PlaceholderForSelectStatus',
    'Admin.Deletion.InStatus',
    'Admin.Deletion.AddStatus',
    'Admin.Users',
    'Admin.Deletion.InactiveUser',
    'Admin.Deletiion.InactiveUsersHint',
    'Admin.Deletion.BlockedUsers',
    'Admin.Deletion.BlockedUsersHint',
    'Admin.Deletion.NonLoggedInUsers',
    'Admin.Deletion.NonLoggedInUsersHint',
    'Admin.Customers',
    'Admin.Deletion.Customers',
    'Admin.Deletion.CustomersHint',
    'Admin.Deletion.BlockedCustomers',
    'Admin.Deletion.BlockedCustomersHint',
    'Admin.Annuality.Months',
    'Admin.Annuality.Years',
    'xmlDataDeletion',
    'Admin.AdminActionAuditTrail',
    'Admin.Deletion.AdminActionAuditTrail',
    'Admin.Deletiion.AdminActionAuditTrailHint',
    'Admin.UserActionAuditTrail',
    'Admin.Deletion.UserActionAuditTrail',
    'Admin.Deletion.UserActionAuditTrailHint',
    'Admin.PricebookAuditTrail',
    'Admin.Deletion.PricebookAuditTrail',
    'Admin.Deletion.PricebookAuditTrailHint',
    'Admin.ProductAuditTrail',
    'Admin.Deletion.ProductAuditTrail',
    'Admin.Deletion.ProductAuditTrailHint',
    'Admin.AttributeAuditTrail',
    'Admin.Deletion.AttributeAuditTrail',
    'Admin.Deletion.AttributeAuditTrailHint',
    'Admin.CustomTableAuditTrail',
    'Admin.Deletion.CustomTableAuditTrail',
    'Admin.Deletion.CustomTableAuditTrailHint',
    'Admin.PlaceholderForSelectPeriod',
    'Admin.Deletion.General',
    'Admin.Deletion.AuditTrail',
    'Msg.DataProtectionSetup.WarningMessage',
    'Admin.Deletion.DataProtectionLog',
    'Admin.Deletion.DataProtectionLogHint',
    'Admin.Deletion.BlockedFromDeletion',
    'Admin.BusinessPartners',
    'Admin.Deletion.BusinessPartners',
    'Admin.Deletion.BusinessPartnersHint',
    'Admin.Deletion.BlockedBusinessPartners',
    'Admin.Deletion.BlockedBusinessPartnersHint',
    'Admin.PlaceholderForSelectCompany',
    'Admin.Deletion.QuoteByStatusAndCompany',
    'Admin.Deletion.QuoteByStatusAndCompanyHint',
    'Admin.Deletion.StatusColumn',
    'Admin.Deletion.CompanyColumn',
    'Admin.add_edit_attribute.LabelDeleteAttValue',
    'Admin.Deletion.PeriodColumn',
    'Admin.AddNewPricingCondition',
    'Admin.Deletion.AddRows',
    'Admin.Deletion.FilterByStatusOrCompany',
    'Admin.Deletion.SaveFailed',

    // View/Export PII
    'xmlViewExport',
    'Admin.ViewExportPii.Customers',
    'Admin.ViewExportPii.BusinessPartner',
    'Admin.ViewExportPii.Users',
    'Admin.ViewExportPii.SearchPlaceholder',
    'Admin.UserGeneral.Name',
    'Admin.UserGeneral.Username',
    'Admin.UserGeneral.UserType',
    'Admin.UserGeneral.Address',
    'Admin.UserGeneral.Email',
    'Admin.ViewExportPii.SearchFilter',
    'Admin.ViewExportPii.SearchData',
    'Admin.ViewExportPii.SearchFilter.Users',
    'Admin.ViewExportPii.SearchFilter.Customers',
    'Admin.ViewExportPii.SearchFilter.CustomTables',
    'Admin.ViewExportPii.SearchFilter.Quotes',
    'Admin.ViewExportPii.SearchFilter.QuoteCustiomFields',
    'Admin.ViewExportPii.SearchFilter.QuoteTables',
    'Admin.ViewExportPii.SearchFilter.Attributes',
    'Admin.ViewExportPii.SearchFilter.Cancel',
    'Admin.ViewExportPii.SearchFilter.Apply',
    'Admin.ViewExportPii.SearchFilter.SearchOnly',
    'Admin.ViewExportPii.SearchFilter.SearchFilter',
    'Admin.UserGeneral.PersonDetails',
    'Admin.UserGeneral.Phone',
    'Admin.UserGeneral.City',
    'Admin.UserGeneral.Country',
    'Admin.UserGeneral.Zip',
    'Admin.ViewExportPii.MoreDetails',
    'Admin.ViewExportPii.LessDetails',
    'Admin.ViewExpPII.QuoteNum',
    'Admin.ViewExpPII.QuoteOwner',
    'Admin.ViewExpPII.customerFullName',
    'Admin.ViewExpPII.businessPartnerFullName',
    'Admin.ViewExpPII.quoteStatus',
    'Admin.ViewExpPII.dateCreated',
    'Admin.ViewExpPII.dateModified',
    'Admin.ViewExpPII.approver',
    'Admin.ViewExpPII.TabName',
    'Admin.ViewExpPII.CustomFieldName',
    'Admin.ViewExpPII.Content',
    'Admin.ViewExportPii.SearchFilter.QuoteItemCustomFields',
    'Admin.ViewExpPII.TableName',
    'Admin.ViewExpPII.ColumnName',
    'Admin.ViewExpPII.ModifiedBy',
    'Admin.ViewExpPII.ColumnValue',
    'Admin.ViewExpPII.TableLabel',
    'Admin.ViewExportPii.ExportData',
    'Admin.ViewExportPii.SearchFilter.CustomerCustomFields',
    'Admin.ViewExportPii.SearchFilter.BusinessPartnerCustomFields',
    'Admin.ViewExportPii.SearchFilter.InvolvedPartyCustomFields',
    'Admin.ViewExportPii.SearchFilter.UserCustomFields',
    'Admin.ViewExportPii.SearchFilter.QuoteCustomFields',
    'Admin.ViewExpPII.isApproverOnQuote',
    'Admin.ViewExpPII.isActionPerformer',
    'Admin.ViewExpPII.QuoteItemCustomFieldName',
    'Admin.ViewExpPII.Label',
    'Admin.ViewExpPII.QuoteCompositeNumber',
    'Admin.ViewExpPII.CustomFieldLabel',
    'Admin.ViewExpPII.OnUser',
    'Admin.ViewExpPII.OnCustomer',
    'Admin.ViewExpPII.OnBusinessPartner',
    'Admin.ViewExportPii.ExportDataExcel',
    'Admin.ViewExportPii.ExportDataPdf',
    'Admin.ViewExpPII.ProductName',

    // Data Protection Log
    'xmlDataProtectionLog',
    'Admin.DataProtection.EntityType',
    'Admin.DataProtection.EntityId',
    'Admin.DataProtection.Field',
    'Admin.DataProtection.OldValue',
    'Admin.DataProtection.NewValue',
    'Admin.DataProtection.Action',
    'Admin.DataProtection.Description',
    'Admin.DataProtection.DatePerformed',
    'Admin.DataProtection.DatePerformedFrom',
    'Admin.DataProtection.DatePerformedTo',
    'Admin.DataProtection.Performer',
    'Admin.DataProtection.QuickSearch',
    'Admin.DataProtection.Total',
    'Admin.DataProtection.Quote',

    // Hangfire servers
    'xmlHangfireSettings',
    'Admin.Hangfire.Title',
    'Admin.Hangfire.TenantName',
    'Admin.Hangfire.CurrentTenantHFUrl',
    'Admin.Hangfire.EditTenantSettings',
    'Admin.Hangfire.TransferHF',
    'Admin.Hangfire.CouldNotLoadTenantJobs',
    'Admin.Hangfire.CurrentTenantJobs',
    'Admin.Hangfire.NewUrl',
    'Admin.Hangfire.CouldNotReachHFServer',

    // Wsdl Management
    'xmlWsdlManagement',
    'Admin.Wsdl.FileName',
    'Admin.Wsdl.SecureUrl',
    'Admin.Wsdl.DeleteMsg',
    'Admin.Wsdl.NewWsdl',
    'Admin.Wsdl.TotalKeys',
    'Admin.Wsdl.QuickSearch',
    'Admin.Wsdl.SaveWsdl',
    'Admin.Wsdl.UploadXmlFile',

    // Credentials management
    'xmlCredentialsManagement',
    'CredentialsStore.NewEntry',
    'CredentialsStore.TotalEntries',
    'CredentialsStore.FilterByName',
    'CredentialsStore.DeleteWarningTitle',
    'CredentialsStore.DeleteWarningMessage',
    'CredentialsStore.SuccessfullyDeleted',

    //Trusted Applications
    'Admin.TrustedApplication.ClientId',
    'Admin.TrustedApplication.ClientSecret',
    'Admin.TrustedApplication.AddNewTrustedApplication',
    'Admin.TrustedApplication.QuickFilter',
    'Admin.TrustedApplications.SamlBearerConfiguration',
    'Admin.TrustedApplications.CertificateHashAlgorithm',
    'Admin.TrustedApplications.ResetSamlBearerConfiguration',
    'Admin.TrustedApplication.JwtTokenConfiguration',
    'Admin.TrustedApplication.JwtTokenSigningKey',
    'Admin.TrustedApplication.GenerateJwtTokenConfiguration',
    'Admin.TrustedApplication.InvalidSamlBearerTokenConfigurationUI',
    'Admin.TrustedApplication.SamlUserIdentifierAttributeSource',
    'Admin.TrustedApplication.SamlUserIdentifierAttributeName',
    'Admin.TrustedApplication.GenerateClientSecret',
    'Admin.TrustedApplication.GenerateJwtTokenSigningKey',
    'Admin.TrustedApplications.RedirectUri',
    'Admin.TrustedApplication.GenerateJwtTokenSigningKey',
    'Admin.TrustedApplication.AddVsCodeExtension',
    'Admin.TrustedApplication.EnableSamlBearerConfiguration',
    'Admin.TrustedApplication.JwtGrant',
    'Admin.TrustedApplication.SamlGrant',
    'Admin.TrustedApplication.AuthorizationCodeGrant',
    'Admin.TrustedApplication.EnableJwtGrant',
    'Admin.TrustedApplication.EnableSamlGrant',
    'Admin.TrustedApplication.EnableAuthorizationCodeGrant',
    'Admin.TrustedApplication.UploadPublicKey',
    'Admin.TrustedApplication.EnablePkce',
    'Admin.TrustedApplication.EnablePkceHint',
    'Admin.TrustedApplication.JwtGrantEnabled',
    'Admin.TrustedApplication.JwtGrantDisabled',
    'Admin.TrustedApplication.SamlGrantEnabled',
    'Admin.TrustedApplication.SamlGrantDisabled',
    'Admin.TrustedApplication.AuthorizationCodeGrantEnabled',
    'Admin.TrustedApplication.AuthorizationCodeGrantDisabled',
    'Admin.TrustedApplication.ClientCredentialsGrant',
    'Admin.TrustedApplication.ClientCredentialsGrantEnabled',
    'Admin.TrustedApplication.ClientCredentialsDisabled',
    'Admin.TrustedApplication.EnableClientCredentialsGrant',
    'Admin.TrustedApplication.ClientCredentialsUser',
    'Admin.TrustedApplication.EnabledGrantTypes',

    //GeoIp blocking
    'Admin.Security.GeoIp.IsEnabled',
    'Admin.Security.GeoIp.xmlGeoIpBlocking',
    'Admin.Security.GeoIp.BaseUrl',
    'Admin.Security.GeoIp.AuthenticationUrl',
    'Admin.Security.GeoIp.ClientId',
    'Admin.Security.GeoIp.ClientSecret',
    'Admin.Security.GeoIp.DecisionApiVersion',

    //Password policy
    'xmlPasswordPolicy',
    'Admin.PasswordPolicy.MinimumLenght',
    'Admin.PasswordPolicy.MaximumLenght',
    'Admin.PasswordPolicy.IncludeLowerCase',
    'Admin.PasswordPolicy.NumberOfPasswordsInHistoryToCheck',
    'Admin.PasswordPolicy.PasswordCreationTokenValidityPeriod',
    'Admin.PasswordPolicy.PasswordCreationTokenValidityPeriodPlaceholder',
    'Admin.PasswordPolicy.IncludeUpperCase',
    'Admin.PasswordPolicy.PasswordExpirationInDays',
    'Admin.PasswordPolicy.PasswordExpirationWarningPeriodInDays',
    'Admin.PasswordPolicy.PasswordExpirationWarningPeriodInDaysPlaceholder',
    'Admin.PasswordPolicy.IncludeNumber',
    'Admin.PasswordPolicy.MaximumNumberOfLoginAttempts',
    'Admin.PasswordPolicy.IncludeSpecialCharacter',
    'Admin.PasswordPolicy.AllowTemporaryPassword',
    'Admin.PasswordPolicy.AllowMailNotificationOnPasswordChange',
    'Admin.QuoteField.CancelWarningTitle',
    'Admin.QuoteField.CancelWarningMsg',
    'Admin.appParams.USE_TEMPORARY_PASSWORD_HINT',
    'Admin.appParams.PASSWORD_EXPIRATION_DAYS_HINT',
    'Admin.PasswordPolicy.IncludeSpecialCharactersHint',

    // Internal Certificate Management
    'Admin.Security.InternalCertificateManager',
    'Admin.Security.InternalCertificateManagement.FindByName',
    'Admin.Security.InternalCertificateManagement.AddNewCertificateButton',
    'Admin.Security.InternalCertificateManagement.AddNewCertificateDialog.Title',
    'Admin.Security.InternalCertificateManagement.AddNewCertificateDialog.PFXFile',
    'Admin.Security.InternalCertificateManagement.AddNewCertificateDialog.Name',
    'Admin.Security.InternalCertificateManagement.AddNewCertificateDialog.Password',
    'Admin.Security.InternalCertificateManagement.AddNewCertificateDialog.CertificateSystemType',
    'Admin.Security.InternalCertificateManagement.SystemType.General',
    'Admin.Security.InternalCertificateManagement.SystemType.MalwareScanner',
    'Admin.Security.InternalCertificateManagement.SystemType.UnifiedMetering',
    'Admin.Security.InternalCertificateManagement.SystemType.UnifiedMeteringManager',
    'Admin.Security.InternalCertificateManagement.Name',
    'Admin.Security.InternalCertificateManagement.ValidFrom',
    'Admin.Security.InternalCertificateManagement.ValidTo',
    'Admin.Security.InternalCertificateManagement.Thumbprint',
    'Admin.Security.InternalCertificateManagement.Active'
];
